import React from 'react';
import styled, { css } from 'styled-components';

import { DetailedCarPreviewSpecificationProps } from '@/components/DetailedCarPreviewSpecification/DetailedCarPreviewSpecification.types';
import SpecificationBadge from '@/components/DetailedCarPreviewSpecification/components/SpecificationBadge';
import CoupeBodyIcon from '@/assets/svg/car/body/coupe.svg';
import FurgonBodyIcon from '@/assets/svg/car/body/van.svg';
import HatchbeckBodyIcon from '@/assets/svg/car/body/hatchback.svg';
import CabrioletBodyIcon from '@/assets/svg/car/body/cabriolet.svg';
import CrossoverBodyIcon from '@/assets/svg/car/body/crossover.svg';
import LiftbackBodyIcon from '@/assets/svg/car/body/liftback.svg';
import MicrobusBodyIcon from '@/assets/svg/car/body/minibus.svg';
import MinivanBodyIcon from '@/assets/svg/car/body/minivan.svg';
import SedanBodyIcon from '@/assets/svg/car/body/sedan.svg';
import ShassiBodyIcon from '@/assets/svg/car/body/chassis.svg';
import UniversalBodyIcon from '@/assets/svg/car/body/wagon.svg';
import VnedorojnikBodyIcon from '@/assets/svg/car/body/suv.svg';
import PickupBodyIcon from '@/assets/svg/car/body/pickup.svg';
import ShootingBrakeBodyIcon from '@/assets/svg/car/body/shooting-brake.svg';
import EngineAnyIcon from '@/assets/svg/detailed-car/previewSpecification/engine/any.svg';
import EngineEcoIcon from '@/assets/svg/detailed-car/previewSpecification/engine/eco.svg';
import FullTransmissionIcon from '@/assets/svg/detailed-car/previewSpecification/transmission/full.svg';
import AutimaticIcon from '@/assets/svg/detailed-car/previewSpecification/gearbox/automatic.svg';
import MechanicIcon from '@/assets/svg/detailed-car/previewSpecification/gearbox/mechanic.svg';
import RobotIcon from '@/assets/svg/detailed-car/previewSpecification/gearbox/robot.svg';
import BatteryIcon from '@/assets/svg/detailed-car/previewSpecification/battery/battery.svg';
import DistanceLimitIcon from '@/assets/svg/detailed-car/previewSpecification/distance-limit/distance-limit.svg';
import { media } from '@/utils/mixin';
import { colors } from '@/constants/theme';

function DetailedCarPreviewSpecification({
  items,
}: DetailedCarPreviewSpecificationProps) {
  const data: Record<string, Record<string, React.ReactNode>> = {
    bodyType: {
      Купе: <CoupeBodyIcon />,
      Фургон: <FurgonBodyIcon />,
      Хэтчбек: <HatchbeckBodyIcon />,
      Кабриолет: <CabrioletBodyIcon />,
      Кроссовер: <CrossoverBodyIcon />,
      Лифтбек: <LiftbackBodyIcon />,
      Микроавтобус: <MicrobusBodyIcon />,
      Автобус: <MicrobusBodyIcon />,
      Минивэн: <MinivanBodyIcon />,
      Седан: <SedanBodyIcon />,
      Шасси: <ShassiBodyIcon />,
      Универсал: <UniversalBodyIcon />,
      Внедорожник: <VnedorojnikBodyIcon />,
      Пикап: <PickupBodyIcon />,
      'Шутинг-брейк': <ShootingBrakeBodyIcon />,
      DEFAULT: <CrossoverBodyIcon />,
    },
    engine: {
      Электро: <EngineEcoIcon />,
      DEFAULT: <EngineAnyIcon />,
    },
    transmission: {
      DEFAULT: <FullTransmissionIcon />,
    },
    gearbox: {
      Механическая: <MechanicIcon />,
      Робот: <RobotIcon />,
      DEFAULT: <AutimaticIcon />,
    },
    battery: {
      DEFAULT: <BatteryIcon className="batteryIcon" />,
    },
    distanceLimit: {
      DEFAULT: <DistanceLimitIcon className="distanceLimitIcon" />,
    },
  };
  return (
    <Component>
      {items.map((item, index) => (
        <SpecificationBadge
          key={index}
          icon={item.svgIcon ? data[item.code][item.svgIcon] : ''}
          label={item.label}
          value={item.value}
        />
      ))}
    </Component>
  );
}

export default DetailedCarPreviewSpecification;

const Component = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 15px;

  ${media.mobile(css`
    grid-template-columns: repeat(1, 1fr);
  `)}

  svg {
    path {
      fill: ${colors.main};
    }

    circle {
      stroke: ${colors.main};
    }
  }

  .batteryIcon {
    path:not(:nth-child(1), :nth-child(2)) {
      stroke: none;
    }

    path:nth-child(1) {
      fill: none;
    }
  }

  .distanceLimitIcon {
    path:nth-child(2) {
      fill: none;
    }

    path:nth-child(5),
    path:nth-child(6) {
      fill: ${colors.white};
    }
  }
`;
